import {useCallback, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {HiOutlineCheck} from 'react-icons/hi2';
import Message from "../../../components/toast-message";
import Loader from "../../../components/form-loader/form-loader";
import PageContainer from "../../../components/page-container";
import TextBox from "../../../components/forms/text-box";
import ThemeSwitch from "../../../components/theme-switch";
import {getMyUserProfile, updateUserProfile} from "../../../services/user/user-service";

function UserProfile() {
    const [formData, setFormData] = useState({
        email: '',
        name: '',
    });

    const [error, setError] = useState({
        name: false,
    });

    const [fetchState, setFetchState] = useState({
        processing: false,
        success: false,
        failed: false,
        message: ''
    });

    const [formState, setFormState] = useState({
        processing: false,
        success: false,
        failed: false,
        message: ''
    });

    async function fetchData() {
        updateFetchState(true, false, false);
        const {response, status} = await getMyUserProfile();
        if (status === 200) {
            setFormData(response);
            updateFetchState(false, true, false);
        } else {
            updateFetchState(false, false, true, 'Unable to fetch data');
        }
    }

    const handleChange = useCallback(event => {
        const targetName = event.target.name;
        formData[targetName] = event.target.value;
        setFormData({...formData});
    });

    useEffect(() => {
        fetchData();
    }, []);

    const updateFetchState = (processing, success, failed, message) => {
        setFetchState(Object.assign({}, {processing, success, failed, message}))
    }

    const updateFormState = (processing, success, failed, message) => {
        setFormState(Object.assign({}, {processing, success, failed, message}))
    }

    const validateForm = () => {
        let valid = true;


        if (!formData.name) {
            error.name = true;
            valid = false;
        } else {
            error.name = false;
        }

        setError(Object.assign({}, error))
        return valid;
    }

    const handleSubmit = useCallback(async (event) => {
        event.preventDefault();
        if (!formState.processing && validateForm()) {
            updateFormState(true, false, false);
            const {response, status} = await updateUserProfile(formData);
            if (status === 200) {
                updateFormState(false, true, false);
            } else {
                console.error("updateUserProfile failed cause", response);
                updateFormState(false, false, true, response);
            }
        }
    });

    return (
        <PageContainer
            title="User Profile"
            subtitle="Your personal account details">

            <form className="max-w-2xl pb-8" onSubmit={handleSubmit}>
                <div className="panel-card">
                    <div className="border-b border-line px-5 py-4">
                        <h3 className="text-base font-semibold tracking-tight text-ink">
                            Account details
                        </h3>
                        <p className="mt-0.5 text-xs text-muted">
                            Your email is used to sign in and cannot be changed.
                        </p>
                    </div>

                    <div className="flex flex-col gap-4 px-5 py-5">
                        {(fetchState.processing || formState.processing) &&
                            <div className="py-2"><Loader/></div>}
                        {fetchState.failed && <Message text={fetchState.message} type="failure"/>}
                        {formState.failed && <Message text={formState.message} type="failure"/>}
                        {formState.success &&
                            <Message text="Successfully updated the profile" type="success"/>}

                        <TextBox
                            label="Email"
                            type="email"
                            name="email"
                            id="email"
                            placeholder="Email"
                            value={formData.email}
                            readOnly
                        />

                        <TextBox
                            label="Name"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="flex flex-wrap items-center justify-end gap-2 rounded-b-2xl border-t border-line bg-raised/40 px-5 py-4">
                        <Link
                            to="/forgot-password"
                            className="inline-flex h-10 items-center justify-center gap-2 rounded-xl border border-line bg-panel px-4 text-sm font-medium text-ink/80 transition-all duration-200 hover:border-muted/40 hover:bg-raised/50 active:scale-[0.97] dark:bg-transparent"
                        >
                            Reset Password
                        </Link>
                        <button
                            type="submit"
                            disabled={formState.processing}
                            className="inline-flex h-10 items-center justify-center gap-2 rounded-xl bg-accent px-4 text-sm font-medium text-accent-ink shadow-sm transition-all duration-200 hover:bg-accent/80 hover:shadow-md active:scale-[0.97] disabled:pointer-events-none disabled:opacity-50"
                        >
                            <HiOutlineCheck className="h-4 w-4"/>
                            Update Profile
                        </button>
                    </div>
                </div>
            </form>

            <section aria-labelledby="appearance-heading" className="panel-card max-w-2xl">
                <div className="flex flex-wrap items-center justify-between gap-4 px-5 py-4">
                    <div>
                        <h3 id="appearance-heading" className="text-base font-semibold tracking-tight text-ink">
                            Appearance
                        </h3>
                        <p className="mt-0.5 text-xs text-muted">
                            System follows your device setting. Saved in this browser.
                        </p>
                    </div>
                    <ThemeSwitch showLabels/>
                </div>
            </section>

        </PageContainer>)
}

export default UserProfile;